<template>
  <div>
    <table width='100%' v-if='showPagination'>
      <tr>
        <td class='text-left'>
          <v-btn icon x-small :disabled='page === 1' @click='first'>
            <v-icon>mdi-chevron-double-left</v-icon>
          </v-btn>
          <v-btn icon x-small :disabled='page === 1' @click='prev'>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </td>
        <td class='text-center caption'>
          {{ pageStart }} - {{ pageEnd}} of {{ items.length }}
        </td>
        <td class='text-right'>
          <v-btn icon x-small :disabled='page === pageCount' @click='next'>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn icon x-small :disabled='page === pageCount' @click='last'>
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </td>
      </tr>
    </table>
    <v-divider></v-divider>
    <div :class="hideScroll ? '' : 'limit-height'">
      <v-data-table
        class='my-table'
        :loading='isLoading'
        :loading-text='loadingText'
        :items='items'
        :headers='headers'
        :page.sync='page'
        :items-per-page='showPagination ? itemsPerPage : -1'
        :search='search'
        disable-sort
        dense
        hide-default-footer
        hide-default-header
      >
        <template v-slot:item.wo='{ item }' class='mx-0 px-0'>
          <wo-tile
            :wo='item'
            :isLoading='isLoading'
            :showInsertBox='showInsertBox'
            :routeDate='routeDate'
            @openCrewVisits='openCrewVisits'
            @openQuickView='openQuickView'
            @woClicked='woClicked'
            @insertBefore='insertBefore'
            @updateWO='updateWO'
            :hideInsertArrows='hideInsertArrows'
          ></wo-tile>
        </template>
        <template v-slot:item.project_name='{ item }'>
          <span v-show='false'>{{item}}</span>
        </template>
        <template v-slot:item.project_site_address='{ item }'>
          <span v-show='false'>{{item}}</span>
        </template>
        <template v-slot:item.project_site_city='{ item }'>
          <span v-show='false'>{{item}}</span>
        </template>
         <template v-slot:item.project_route_group='{ item }'>
          <span v-show='false'>{{item}}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import WOTile from './WOTile'

export default {
  name: 'wo-list',
  props: {
    items: {
      required: true
    },
    showAsRouteItems: {
      required: false,
      type: Boolean,
      default: false
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    loadingText: {
      required: false,
      default: 'Loading WOs'
    },
    showPagination: {
      required: false,
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      required: false,
      default: 20
    },
    hideScroll: {
      required: false,
      type: Boolean,
      default: false
    },
    hideInsertArrows: {
      required: false,
      type: Boolean,
      default: false
    },
    showInsertBox: {
      required: true
    },
    search: {
      required: false
    },
    routeDate: {
      // can be passed in for conflict checking
      required: false
    }
  },
  data: () => ({
    headers: [
      { text: '', value: 'wo' },
      { text: '', value: 'project_name'},
      { text: '', value: 'project_site_address'},
      { text: '', value: 'project_site_city'}
    ],
    page: 1
  }),
  computed: {
    pageCount () {
      return Math.floor(this.items.length / this.itemsPerPage) + (this.items.length % this.itemsPerPage ? 1 : 0)
    },
    pageStart () {
      if (this.items.length) {
        return (this.itemsPerPage * this.page) - this.itemsPerPage + 1
      }
      return 0
    },
    pageEnd () {
      if (this.itemsPerPage * this.page > this.items.length) {
        return (this.itemsPerPage * (this.page - 1)) + (this.items.length % this.itemsPerPage)
      } else {
        return (this.itemsPerPage * this.page)
      }
    }
  },
  methods: {
    first () {
      this.page = 1
    },
    prev () {
      this.page -= 1
    },
    next () {
      this.page += 1
    },
    last () {
      this.page = this.pageCount
    },
    woClicked (wo) {
      this.$emit('woClicked', wo)
    },
    insertBefore (wo) {
      this.$emit('insertBefore', wo)
    },
    openQuickView (wo) {
      this.$emit('openQuickView', wo)
    },
    openCrewVisits (wo) {
      this.$emit('openCrewVisits', wo)
    },
    updateWO (wo) {
      this.$emit('updateWO', wo)
    }
  },
  components: {
    'wo-tile': WOTile
  }
}
</script>

<style>
.my-table td {
  padding: 0px !important;
}

.limit-height {
  max-height: 450px;
  overflow-y: auto;
}
</style>
